import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-6 text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold mb-6 text-black">Privacy Policy</h1>

      <p className="mb-6">
        Last updated: <strong>31 jan 2026</strong>
      </p>

      <p className="mb-6">
        Your privacy is important to us. This Privacy Policy explains how we
        collect, use, store, and protect your personal information when you use
        our website, request a quote, communicate with us, or make payments.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        1. Information We Collect
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>Name and contact details (such as phone number)</li>
        <li>Message or inquiry details you submit</li>
        <li>Location or project details (if provided)</li>
        <li>
          Communication data related to RCS, WhatsApp, SMS, or calls (such as
          message timestamps and delivery status)
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        2. Messaging & Communication Consent
      </h2>
      <p>
        By submitting your phone number and providing consent, you agree to
        receive communication from us via <strong>Google RCS, WhatsApp, SMS,
        or phone calls</strong> for service-related purposes such as quotes,
        order updates, and customer support.
      </p>
      <p className="mt-2">
        You may opt out of receiving messages at any time by contacting us
        directly or using available opt-out options where applicable.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        3. Payment Information
      </h2>
      <p>
        Payments made through our website are processed securely using
        authorized third-party payment gateways. We do not store or have access
        to your card details, UPI information, CVV, or banking credentials.
      </p>
      <p className="mt-2">
        Payment service providers handle your data according to their own
        privacy and security policies and comply with applicable regulatory
        requirements.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        4. Use of Information
      </h2>
      <ul className="list-disc pl-6 space-y-2">
        <li>To respond to inquiries and provide quotes</li>
        <li>To communicate service updates and confirmations</li>
        <li>To process payments securely</li>
        <li>To improve our services and customer experience</li>
        <li>To comply with legal and regulatory obligations</li>
      </ul>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        5. Data Sharing
      </h2>
      <p>
        We do not sell or rent your personal data. Information may be shared only
        with trusted service providers such as payment gateways and messaging
        platforms, or when required by law.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        6. Data Security
      </h2>
      <p>
        We implement reasonable security measures to protect your information,
        including secure servers and restricted access. However, no online data
        transmission can be guaranteed to be completely secure.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        7. Data Retention
      </h2>
      <p>
        Personal data is retained only for as long as necessary to fulfill
        service requirements and comply with legal obligations. Data is
        securely deleted or anonymized when no longer required.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        8. Your Rights
      </h2>
      <p>
        You have the right to access, correct, or request deletion of your
        personal information and to withdraw consent for communication at any
        time.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        9. Updates to This Policy
      </h2>
      <p>
        This Privacy Policy may be updated from time to time. Any changes will
        be posted on this page with a revised date.
      </p>

      <h2 className="text-xl font-semibold mt-8 mb-3 text-black">
        10. Contact Us
      </h2>
      <p>
        If you have any questions about this Privacy Policy or our data
        practices, please contact us:
      </p>
      <p className="mt-2">
        <strong>Business Name:</strong> __________ <br />
        <strong>Phone:</strong> __________ <br />
        <strong>Email:</strong> __________
      </p>
    </div>
  );
};

export default PrivacyPolicy;
